import React from 'react';
export function DashboardShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15327" data-mp="3uj6ozbchqgg0">
      <span className="sr-only" data-id="element-15328" data-mp="1jir86uex5ve8">Loading dashboard…</span>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-15329" data-mp="1jku949hm18xq">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15330" data-mp="1ai2u5zpizv1c">
            <div className="flex justify-between items-start mb-4" data-id="element-15331" data-mp="15qump97rajqt">
              <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15332" data-mp="15pjij8aef9z6" />
              <div className="w-10 h-10 bg-gray-200 rounded-md" data-id="element-15333" data-mp="10t1hoji6vvs4" />
            </div>
            <div className="h-8 w-40 bg-gray-200 rounded mb-2" data-id="element-15334" data-mp="vu81ukffjsos" />
            <div className="h-3 w-24 bg-gray-200 rounded" data-id="element-15335" data-mp="rrlfgz1j2zyz" />
          </div>)}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-15336" data-mp="mryv85na8jgo">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15337" data-mp="g1ieihalxwzp">
            <div className="flex justify-between items-center mb-4" data-id="element-15338" data-mp="ktsaadyelr9w">
              <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-15339" data-mp="71lwuzmmxye5" />
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15340" data-mp="736p2ilh958u" />
            </div>
            <div className="h-64 bg-gray-200 rounded-md" data-id="element-15341" data-mp="b3qnrqlp8gx3" />
          </div>)}
      </div>
      {/* Activity Section */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15342" data-mp="yqf6ufmg2ffa">
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" data-id="element-15343" data-mp="13qbfwta00x1p" />
        <div className="space-y-3" data-id="element-15344" data-mp="ps3hsi187poy">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg" data-id="element-15345" data-mp="pu6bpd5i22yy">
              <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-15346" data-mp="3ah11flc8vfrw" />
              <div className="flex-1 space-y-2" data-id="element-15347" data-mp="3fgvths7rabej">
                <div className="h-4 w-64 bg-gray-200 rounded" data-id="element-15348" data-mp="3fiqgdc2l8dl9" />
                <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-15349" data-mp="1l1gknpt7i7ra" />
              </div>
              <div className="h-4 w-20 bg-gray-200 rounded" data-id="element-15350" data-mp="1g23zralwbarc" />
            </div>)}
        </div>
      </div>
    </div>;
}